import TextBanner from "./TextBannerView";

export default TextBanner;
